<a class="external-link" href="{{ href }}" target="_blank">
  <ng-content></ng-content>&nbsp;<span
    class="external-link__icon glyphicon glyphicon-external-link"
  ></span>
</a>
